import { SelectOption } from '../types';

export const UserRoles = {
  ANALYST: 'analyst',
  EMPLOYEE: 'employee',
  ADMIN: 'admin',
  ACCOUNTS: 'accounts',
} as const;

export const JobStatus = {
  NOT_STARTED: 'Not Started',
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
  ON_HOLD: 'On Hold',
  ASSIGNED: 'Assigned',
} as const;

export const Departments = {
  DRAWING: 'drawing',
  DESIGN: 'design',
  SITE_VISIT: 'site visit',
} as const;

export const milestoneCompleteStatus: string[] = [
  'Milestone Achieved',
  'Payment Requested',
  'Proforma Sent',
  'Amount Credited',
  'Invoice Sent',
];

export const receptionistName = 'Receptionist Name';

export const address = `Office no. 401 & 402, Vasant Bahawa Apt,\nSr. no.20, Hissa no. 3/2/8, Plot no. 6,\nBavadhan (KH), Pune-4110021\nPhone: 020-2952 8584.`;

export const maxWorkingHoursDaily = 8.5;
export const maxWorkingHoursWeekly = maxWorkingHoursDaily * 5;

export const departmentOptions: SelectOption[] = [
  { value: 'Drawing', label: 'Drawing' },
  { value: 'Design', label: 'Design' },
  { value: 'Site Visit', label: 'Site Visit' },
];

export const minimumTotalAmount = 25000;
export const jobWorkType: string[] = ['Allied Work', 'Building Work'];
export const jobBuildingWorkType: string[] = [
  'Residential Building',
  'Commercial Building',
  'Residential & Commercial Building',
  'Industrial Building',
  'Factory Shed',
  'Institutional/School Building',
  'Hospital Building',
  'Mangal Karyalay',
  'Bungalow',
  'Row House',
  'Farm House',
  'Club House',
  'Retaining Wall',
  'Compound Wall',
  'Swimming Tank',
  'Entrance Gate',
  'Hotel Building',
  'Restaurant Building',
  'Road & Culverts',
];
export const sanctioningAuthority: string[] = ['PMC', 'PCMC', 'PMRDA'];
export const municipalCouncils: string[] = [
  'Ambegaon', 'Baramati', 'Bhor', 'Daund', 'Haveli',
  'Indapur', 'Junnar', 'Khed', 'Maval', 'Mulshi',
  'Pune City', 'Puranndar', 'Shirur', 'Velhe',
];

export interface DocumentTitle {
  title: string;
  handle: string;
  disableInJobCreation: boolean;
}

export const jobDocumentsTitles: DocumentTitle[] = [
  { title: 'Appointment letter', handle: 'appointment_letter', disableInJobCreation: false },
  { title: 'Acceptance-A letter', handle: 'acceptance_a_letter', disableInJobCreation: false },
  { title: 'Acceptance-B letter', handle: 'acceptance_b_letter', disableInJobCreation: false },
  { title: 'NOC', handle: 'noc', disableInJobCreation: false },
  { title: 'Plinth certificate', handle: 'plinth_certificate', disableInJobCreation: true },
  { title: 'Stability A certificate', handle: 'stability_a_certificate', disableInJobCreation: true },
  { title: 'Stability B certificate', handle: 'stability_b_certificate', disableInJobCreation: true },
  { title: 'Completion certificate', handle: 'completion_certificate', disableInJobCreation: true },
  { title: 'Lift Stability certificate', handle: 'lift_stability_certificate', disableInJobCreation: true },
];

export interface FinancialDocumentTitle {
  title: string;
  handle: string;
  disableInJobCreation?: boolean;
}

export const financialDocumentsTitles: FinancialDocumentTitle[] = [
  { title: 'Approved Quotation', handle: 'approved_quotation' },
];

export const paymentMethodOptions: SelectOption[] = ['Cash', 'UPI', 'IMPS', 'RTGS', 'NEFT', 'DD'].map((item) => ({
  label: item,
  value: item,
}));

export const leaveTypes: string[] = [
  'Casual Leave', 'Sick Leave', 'Earned Leave', 'Compensatory Off',
  'Maternity Leave', 'Paternity Leave', 'Leave Without Pay',
];

export const expenseTypes: string[] = [
  'Office supplies', 'Gift voucher', 'Site visit', 'Hotel expenses',
  'Travel expenses', 'Training and education expense', 'Dues and subscription expense',
  'Utilities', 'Other',
];
